import React from 'react';
import styled, { css } from 'styled-components';

import { pluralizeReviews } from '@lt/components/utils/pluralizeUtils';

type HotelCardRatingProps = {
  value?: number;
  reviewsCount?: number;
  className?: string;
};

const HotelRatingSquare = ({
  value,
  reviewsCount = 0,
  className = '',
}: HotelCardRatingProps) => {
  const formatter = new Intl.NumberFormat('ru-RU');

  if (!value) return null;

  let decimal = value.toFixed(1);
  if (decimal === '10.0') decimal = decimal.slice(0, -2);

  return (
    <Rating className={className} $value={value}>
      <RatingText>{decimal}</RatingText>
      {Boolean(reviewsCount) && (
        <ReviewsCount>
          <span>{formatter.format(reviewsCount)}</span>&nbsp;
          <span>{pluralizeReviews(reviewsCount)}</span>
        </ReviewsCount>
      )}
    </Rating>
  );
};

const Rating = styled.div<{ $value: number }>`
  display: flex;
  align-items: center;
  flex-direction: column;

  padding: 3px 8px;
  border-radius: var(--border-radius);
  background-color: var(--background);

  ${({ $value }) =>
    $value >= 8.0 &&
    css`
      background-color: var(--lime);
    `};
`;

const RatingText = styled.div`
  color: var(--black);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
`;

const ReviewsCount = styled.div`
  color: var(--black);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
`;

export default HotelRatingSquare;
